export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7830.1bc0ebd3.jpg";